/**
 * WebMCP 硬降工具
 * 方块直接落到底部
 */
/* eslint-disable */
var want = require('../../unit/').want;
var t = require('../lang').t;
var actions = require('../../actions').default;
var states = require('../../control/states').default;
var music = require('../../unit/music').music;
var store = require('../../store').default;

/**
 * 执行硬降操作
 */
function hardDrop() {
  var state = store.getState();

  // 检查锁定状态
  if (state.get('lock')) {
    return { success: false, error: t('游戏处于锁定状态，无法硬降', 'Game is locked, cannot hard drop') };
  }

  var cur = state.get('cur');

  // 检查是否有当前方块
  if (cur === null) {
    return { success: false, error: t('没有活动方块', 'No active block') };
  }

  // 如果游戏暂停，先恢复
  if (state.get('pause')) {
    states.pause(false);
    return { success: true, message: t('游戏已从暂停恢复，请再次执行硬降', 'Game resumed from pause, hard drop again') };
  }

  // 播放下落音效
  if (music.fall) {
    music.fall();
  }

  // 计算落到底部的位置
  var index = 0;
  var bottom = cur.fall(index);
  var matrix = state.get('matrix');

  while (want(bottom, matrix)) {
    bottom = cur.fall(index);
    index++;
  }

  // 获取最终位置（index-2 是最后一个有效位置）
  var finalIndex = index - 2;
  if (finalIndex < 0) {
    finalIndex = 0;
  }
  var finalBottom = cur.fall(finalIndex);
  var shape = finalBottom.shape;
  var xy = finalBottom.xy;

  // 更新矩阵
  var newMatrix = matrix;
  // xy 是 Immutable List [row, col]，即 [y, x]
  var xyRow = xy && typeof xy.get === 'function' ? xy.get(0) : xy[0];
  var xyCol = xy && typeof xy.get === 'function' ? xy.get(1) : xy[1];

  for (var k1 = 0; k1 < shape.size; k1++) {
    for (var k2 = 0; k2 < shape.get(k1).size; k2++) {
      var n = shape.get(k1).get(k2);
      if (n && xyRow + k1 >= 0) {
        var line = newMatrix.get(xyRow + k1);
        line = line.set(xyCol + k2, 1);
        newMatrix = newMatrix.set(xyRow + k1, line);
      }
    }
  }

  // 更新状态
  store.dispatch(actions.moveBlock(finalBottom));
  store.dispatch(actions.drop(true));
  setTimeout(function() {
    store.dispatch(actions.drop(false));
  }, 100);

  // 触发下一个方块
  states.nextAround(newMatrix);

  return {
    success: true,
    message: t('方块已硬降到底部', 'Block hard-dropped to bottom'),
    finalPosition: [xyCol, xyRow],  // 返回 [x, y] 格式
    dropDistance: finalIndex + 1,
  };
}

/**
 * WebMCP 工具定义
 */
module.exports = {
  name: 'tetris_hard_drop',
  description: t('将当前方块直接落到底部（硬降/硬着陆）', 'Drop the current block straight to the bottom (hard drop)'),
  inputSchema: {
    type: 'object',
    properties: {},
  },
  execute: function() {
    var result = hardDrop();
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/hardDrop.js